import type { RootState } from '../types/store';
import getActiveSubscriptions from './active-subscriptions';
import messenger from '../messenger';
import type { Subscription } from '../types/subscription';

function getActiveSubscriptionById(state: RootState, id: string): Subscription | null {
  const activeSubscriptions = getActiveSubscriptions(state);

  if (!activeSubscriptions) throw new Error(messenger.missingData('active'));

  return activeSubscriptions.find((subscription) => subscription.id === id) || null;
}

export default getActiveSubscriptionById;
